// components/landingPage/OrderManagement.jsx
import React from 'react';

const OrderManagement = () => {
  return (
    <section className="py-20 bg-gray-50 px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">
          Streamlined Order Management
        </h2>
        <p className="text-xl text-center text-gray-600 mb-12">
          Track and manage all your product orders efficiently with real-time updates
        </p>

        <div className="bg-white rounded-2xl shadow-lg overflow-hidden max-w-4xl mx-auto">
          {/* Header */}
          <div className="bg-gradient-to-r from-emerald-600 to-green-600 p-6 text-white">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="text-2xl font-bold">Order Management</h3>
                <p className="text-emerald-100">Updated: 9:15:40 PM</p>
              </div>
              <div className="bg-white/20 rounded-lg px-4 py-2">
                <select className="bg-transparent text-white border-none outline-none">
                  <option>Select Product</option>
                  <option>Seaweed Extract</option>
                  <option>Organic Pest Repellents</option>
                </select>
              </div>
            </div>
          </div>

          {/* Order Stats */}
          <div className="p-6 border-b">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="space-y-4">
                <div className="flex justify-between items-center p-4 bg-emerald-50 rounded-lg">
                  <span className="font-semibold">Seaweed Extract</span>
                  <div className="text-right">
                    <div className="font-bold text-emerald-600">4 orders</div>
                    <div className="text-sm text-gray-600">3 delivered • 1 rejected</div>
                  </div>
                </div>
                <div className="flex justify-between items-center p-4 bg-blue-50 rounded-lg">
                  <span className="font-semibold">Organic Pest Repellents</span>
                  <div className="text-right">
                    <div className="font-bold text-blue-600">2 orders</div>
                    <div className="text-sm text-gray-600">2 delivered</div>
                  </div>
                </div>
              </div>
              
              <div className="bg-gray-50 rounded-lg p-4">
                <h4 className="font-semibold mb-3">Recent Activity</h4>
                <div className="space-y-3">
                  <div className="flex justify-between text-sm">
                    <span>K Kelvin Oduor</span>
                    <span className="text-emerald-600 font-medium">Delivered</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span>Farmer One</span>
                    <span className="text-emerald-600 font-medium">Delivered</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="p-6 text-center">
            <button className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-3 px-8 rounded-xl transition-colors inline-flex items-center gap-2">
              View All Orders
              <span>→</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OrderManagement;